import { P } from './palette';
export function deathAnimation(ctx:CanvasRenderingContext2D,x:number,y:number,frame:number,water:boolean):void {
  x=Math.round(x);y=Math.round(y);
  if(frame<18){
    const color=water?P.blue:P.red;ctx.fillStyle=color;
    for(let i=0;i<8;i++){const a=i*Math.PI/4;const r=3+Math.floor(frame/4);ctx.fillRect(Math.round(x+Math.cos(a)*r)-1,Math.round(y+Math.sin(a)*r)-1,3,3);}
    ctx.fillStyle=P.white;ctx.fillRect(x-2,y-2,4,4);
  } else {
    ctx.fillStyle=P.white;ctx.fillRect(x-4,y-5,8,7);ctx.fillRect(x-2,y+2,4,2);
    ctx.fillRect(x-6,y+5,12,1);ctx.fillRect(x-5,y+4,2,3);ctx.fillRect(x+3,y+4,2,3);
    ctx.fillStyle=P.black;ctx.fillRect(x-3,y-3,2,2);ctx.fillRect(x+1,y-3,2,2);ctx.fillRect(x,y,1,2);
  }
}
